import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeTherapyContractCoverage from './ChangeTherapyContractCoverage';
import ChangeTherapyCoverage from './ChangeTherapyCoverage';
import ChangeAccidentMainCoverage from './ChangeAccidentMainCoverage';
import ChangeAccidentSideCoverage from './ChangeAccidentSideCoverage';
import ChangeAccidentJobClass from "./ChangeAccidentJobClass";
import ChangePriceAccident from "./ChangePriceAccident";

import ChangeTherapyBaseinsur from './ChangeTherapyBaseinsur';
import ChangeTherapyAge from './ChangeTherapyAge';
import ChangePriceTherapy from './ChangePriceTherapy';
import ChangeTherapyFranchise from "./ChangeTherapyFranchise";



const styles = theme => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    , paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },


});

class ChangeTherapy extends Component {
    cookies=new Cookies();
    constructor(props) {
        super(props);
        this.state = {
            value:0,
        }}

    componentDidMount() {

    }
    handleChange= (event,newValue) => {
        this.setState({ value:newValue });
    }
    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div>
                <AppBar position="sticky"color="primary" >

                    <Tabs
                        style={{height:'60px',textAlign:'center'}}
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="secondary"
                        textColor={'#000000'}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        <Tab label="پوشش اصلی"  />
                        <Tab label="پوشش فرعی"  />
                        <Tab label="طبقه شغلی"  />
                        <Tab label="قیمت بیمه حوادث "  />
                        <Tab label="قیمت بیمه درمان "  />
                    </Tabs>


                </AppBar>
                {(value===0)?<ChangeAccidentMainCoverage  props={this.props}/>:null}
                {(value===1)?<ChangeAccidentSideCoverage  props={this.props}/>:null}
                {(value===2)?<ChangeAccidentJobClass  props={this.props}/>:null}
                {(value===3)?<ChangePriceAccident  props={this.props}/>:null}
                {(value===4)?<ChangePriceTherapy  props={this.props}/>:null}

            </div>
        );
    }
}

export default  withStyles(styles)(ChangeTherapy);
